export const HALL_OPTIONS = [
  // ── Single halls ──────────────────────────────────────────────
  { key: "Nova",                      capacity: 250,  type: "single"  },
  { key: "Titan",                     capacity: 250,  type: "single"  },
  { key: "Lunar",                     capacity: 250,  type: "single"  },
  { key: "Eclipse",                   capacity: 250,  type: "single"  },
  // ── 2-hall combos ─────────────────────────────────────────────
  { key: "Nova + Titan",              capacity: 450,  type: "combo"   },
  { key: "Eclipse + Lunar",           capacity: 450,  type: "combo"   },
  { key: "Titan + Lunar",             capacity: 450,  type: "combo"   },
  // ── 3-hall combos ─────────────────────────────────────────────
  { key: "Nova + Titan + Lunar",      capacity: 650,  type: "combo"   },
  { key: "Eclipse + Lunar + Titan",   capacity: 650,  type: "combo"   },
  // ── Full hall ─────────────────────────────────────────────────
  { key: "Full Hall",                 capacity: 900,  type: "combo"   },
  // ── Outdoor / patio ───────────────────────────────────────────
  { key: "Outdoor Ceremony",          capacity: 500,  type: "outdoor" },
  { key: "Second Floor Patio",        capacity: 150,  type: "outdoor" },
  // ── Special configurations ────────────────────────────────────
  { key: "Standing",                  capacity: 2000, type: "special" },
  { key: "Theatre Style",             capacity: 1500, type: "special" },
  // ── Individual rooms ──────────────────────────────────────────
  { key: "Studio Room",               capacity: 999,  type: "room"    },
  { key: "Office Room",               capacity: 999,  type: "room"    },
  { key: "Board Room",                capacity: 999,  type: "room"    },
  { key: "Half Lobby",                capacity: 999,  type: "room"    },
  { key: "Full Lobby",                capacity: 999,  type: "room"    },
] as const;

export type HallKey = typeof HALL_OPTIONS[number]["key"];

export const DAY_TYPES = ["Mon-Thu", "Fri", "Sat", "Sun", "Holiday"] as const;
export type DayType = typeof DAY_TYPES[number];

export const TIME_SLOTS = [
  { value: "AM",       label: "Morning  ·  8:00 AM – 12:00 PM", timeRange: "8:00 AM – 12:00 PM", startTime: "08:00", endTime: "12:00" },
  { value: "NOON",     label: "Noon  ·  12:00 PM – 5:00 PM",    timeRange: "12:00 PM – 5:00 PM", startTime: "12:00", endTime: "17:00" },
  { value: "PM",       label: "Evening  ·  6:00 PM – 1:00 AM",  timeRange: "6:00 PM – 1:00 AM",  startTime: "18:00", endTime: "01:00" },
  { value: "FULL_DAY", label: "Full Day  ·  8:00 AM – 1:00 AM", timeRange: "8:00 AM – 1:00 AM",  startTime: "08:00", endTime: "01:00" },
] as const;

export type TimeSlot = typeof TIME_SLOTS[number]["value"];

/** Sentinel value meaning "applies to every hall" */
export const ALL_HALLS = "all";
